import Commands from "./commands";

class Action extends Commands {
    constructor(registry) {
        super("action", registry);
    }

    async execute(node, emitter, options) {
        if (!options.createAction || !options.executeAction) {
            console.log("Action could not be executed.");
            return;
        }
        const actionParams = await emitter(node.params[0], options);
        const action = options.createAction(actionParams);
        return options.executeAction(action);
    }
}

export default Action;
